module.exports = __webpack_public_path__ + "img/Subdivisions.89f6ffa4.svg";